$(document).ready(function () {
  $(".qty-btn").on("click", function () {
    let variantId = $(this).data("variant-id");
    let input = $(`.qty-input[data-variant-id="${variantId}"]`);
    let currentValue = parseInt(input.val());

    if ($(this).data("action") === "increase") {
      input.val(currentValue + 1);
    } else if ($(this).data("action") === "decrease" && currentValue > 0) {
      input.val(currentValue - 1);
    }
  });

  $(".mrk-add-items").on("click", function (event) {
    let hasSelection = false;

    $(".qty-input").each(function () {
      if (parseInt($(this).val()) > 0) {
        hasSelection = true;
        return false; 
      }
    });

    if (!hasSelection) {
      event.preventDefault();
      alert("Please select at least one variant.");
    }
  });

  $(".mrk-add-items").on("click", function () {
    let itemsToAdd = [];

    $(".mrk-qty").each(function () {
      let qty = parseInt($(this).val());
      if (qty > 0) {
        let variantId = $(this).closest("td").find(".mrk-variant-id").val();
        let itemObj = {
          quantity: qty,
          id: variantId
        };
        itemsToAdd.push(itemObj);
      }
    });

    if (itemsToAdd.length > 0) {
      addinToCart(itemsToAdd);
    } else {
      alert("Please select at least one variant.");
    }
  });

  function addinToCart(items) {
    $("body").addClass("loading");

    CartJS.addItems(items, {
      "success": function (data, textStatus, jqXHR) {
        setTimeout(function () {
          $("body").removeClass("loading showOverly");
          $(".block-cart").addClass("active");
        }, 1000);

        drawerTimeout = setTimeout(function () {
          $(".block-cart").removeClass("active");
        }, 7000);
      },
      "error": function (jqXHR, textStatus, errorThrown) {
        let errormsg = JSON.parse(jqXHR.responseText).description;
        $("body").removeClass("loading");
        $(".error-message").text(errormsg);
        $("body").addClass("showOverly");
        $("#errorDrawer").fadeIn(500);

        drawerTimeout = setTimeout(function () {
          $("body").removeClass("loading showOverly");
          $("#errorDrawer").fadeOut(200);
        }, 6000);
      }
    });
  }
});